import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EItemType } from '../../../order/interfaces/order.interface';
import { SnackBarConfig } from '../../../shared/configs/snackbar.config';

// SERVICES
import { OrderSalesApiService } from '../../../shared/services/api/order/order-sales-api.service';
import { trackById } from '../../../shared/util/track-by.util';
import { IPicklistOrderItems } from '../../interfaces/picklist.interface';

@Component({
  selector: 'lum-picklist-kits',
  templateUrl: './picklist-kits.component.html',
  styleUrls: ['./picklist-kits.component.scss'],
})
export class PicklistKitsComponent implements OnInit, OnDestroy {
  @Input()
  pickListId :number = 0;

  loading :boolean = false;
  orderItems :IPicklistOrderItems[] = [];
  showKitItems :boolean[] = [];
  eItemType = EItemType;

  trackById = trackById;

  private onDestroy$ = new Subject();

  constructor(
    private orderSalesApiService :OrderSalesApiService,
    private snackBar :MatSnackBar,
    private cd :ChangeDetectorRef,
  ) {}

  ngOnInit() :void {
    this.loadOrderSalesByKit();
  }

  refresh() :void {
    this.loadOrderSalesByKit();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  toggleKitItems(index :number) :void {
    this.showKitItems[index] = !this.showKitItems[index];
  }

  private loadOrderSalesByKit() :void {
    this.loading = true;
    this.orderSalesApiService
      .getOrderSalesByKit({
        picklistId: this.pickListId.toString(),
      })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (response :IPicklistOrderItems[]) => {
          this.loading = false;
          this.orderItems = response;

          // Set showKitItems to true for each kit item
          this.initShowKitItems();
        },
        error: (error :any) => {
          this.loading = false;
          this.snackBar.open(`Error loading kits: ${error?.message} `, 'Fail', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
        },
      });
  }

  private initShowKitItems() :void {
    this.sortedOrderItems.forEach(
      (orderItem :IPicklistOrderItems, index :number) => {
        this.showKitItems[index] = orderItem?.rfq?.type === EItemType.KIT;
      },
    );
    this.cd.detectChanges();
  }

  get sortedOrderItems() :IPicklistOrderItems[] {
    return this.orderItems.sort((a, b) => {
      if (a?.rfq?.type === EItemType.KIT && b?.rfq?.type !== EItemType.KIT) {
        return -1; // put a before b
      }
      if (a?.rfq?.type !== EItemType.KIT && b?.rfq?.type === EItemType.KIT) {
        return 1; // put b before a
      }

      return 0; // leave a and b unchanged with respect to each other
    });
  }
}
